import { c as _c } from "react/compiler-runtime";
import type { BusinessDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import useStore from '../../hooks/use-store';
import type { ApplyEditMutation } from '../base-node';
import BusinessInformationSection from './components/business/information-section';
type BusinessDataProps = {
  node: BusinessDataNodeProps;
  mutation: ApplyEditMutation;
};
const BusinessData = t0 => {
  const $ = _c(4);
  const {
    node,
    mutation
  } = t0;
  const {
    data: t1
  } = useStore();
  const {
    canEdit
  } = t1;
  let t2;
  if ($[0] !== canEdit || $[1] !== mutation || $[2] !== node) {
    t2 = <div className="flex flex-col gap-4 pb-4"><BusinessInformationSection node={node} mutation={mutation} canEdit={canEdit} /></div>;
    $[0] = canEdit;
    $[1] = mutation;
    $[2] = node;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default BusinessData;